/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_appsync_graphqlEndpoint": "https://wb5fdl2jgbemjmsoihclleidx4.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "restApiChedar",
            "endpoint": "https://h5omuwdu45.execute-api.eu-west-2.amazonaws.com/production",
            "region": "eu-west-2"
        },
        {
            "name": "subscriptionApi",
            "endpoint": "https://7lojwvow85.execute-api.eu-west-2.amazonaws.com/production",
            "region": "eu-west-2"
        },
        {
            "name": "webhooks",
            "endpoint": "https://45rkqcclp3.execute-api.eu-west-2.amazonaws.com/production",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:06ae93a7-50ea-4f16-95ba-1effc62a5242",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_6tgqn3XWM",
    "aws_user_pools_web_client_id": "3tggugdh4q4mpvd82qhvf4hnpb",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "chedarv2staging210920-production",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
